module.exports = __webpack_public_path__ + "static/colors-tagging-content-dont-10ba67139d2204c1ac9cc232f52e3676.png";